import m from "../../geodata/es2015/latviaHigh";
window.am4geodata_latviaHigh = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/latviaHigh.js
// module id = null
// module chunks = 